import React from 'react';
import { Link } from "react-router-dom";

import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

import FundraisingHeader from "../layout/header";
import FundraisingFooter from '../layout/footer';


const NamingOpportunities = () => {
    // Data for the naming tree options (replicating the tree leaves in the image)
    const namingLevels = [
        { title: 'Autism Classroom', price: '$50,000', top: '10%', left: '20%' },
        { title: 'Sensory Room', price: '$35,000', top: '25%', left: '65%' },
        { title: 'Therapy Suite', price: '$25,000', top: '45%', left: '15%' },
        { title: 'Family Resource Center', price: '$100,000', top: '50%', left: '55%' },
        { title: 'Playground', price: '$20,000', top: '70%', left: '25%' },
        { title: 'Parent Training Room', price: '$40,000', top: '80%', left: '65%' },
    ];

    return (
        <>
            <FundraisingHeader />
            <main className="overflow-hidden" style={{ marginTop: "-20px" }}>

                {/* ================= HERO SECTION (Cinematic Image Overlay) ================= */}
                <section className="position-relative overflow-hidden" style={{ minHeight: '85vh', backgroundColor: '#0f172a' }}>
                    
                    {/* Background Image */}
                    <img
                        src="/assets/images/fundraising/04_naming_opportunities_background_2.jpg"
                        alt="Naming Opportunities Tree"
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{ objectFit: 'cover', objectPosition: 'center' }}
                    />

                    {/* Dark Gradient Overlay for text readability */}
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            background: 'linear-gradient(90deg, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.85) 10%, rgba(15,23,42,0.2) 100%)',
                            zIndex: 1,
                        }}
                    ></div>

                    <div className="container position-relative d-flex flex-column justify-content-center" style={{ zIndex: 2, minHeight: '85vh' }}>
                        <div className="row">
                            <div className="col-lg-6 py-5">
                                
                                {/* Headline */}
                                <h1
                                    className="fw-bold mb-4 text-white"
                                    style={{ 
                                        fontFamily: '"Playfair Display", Georgia, serif', 
                                        fontSize: 'clamp(3rem, 5vw, 4.5rem)', 
                                        lineHeight: 1.05,
                                        textShadow: '0 4px 20px rgba(0,0,0,0.3)'
                                    }}
                                >
                                    Naming <br />
                                    Opportunities.
                                </h1>

                                <p className="lh-lg mb-5" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.15rem', maxWidth: '480px', fontWeight: 500 }}>
                                    Leave a lasting legacy by naming a space that will change the lives of children and families for generations to come.
                                </p>

                                {/* CTA Button */}
                                <Link to="/campaign-contact" className="text-decoration-none">
                                    <button
                                        className="btn fw-bold rounded-pill px-4 py-3 border-0 d-inline-flex align-items-center gap-2"
                                        style={{ 
                                            background: '#fbbf24', 
                                            color: '#1f2937', 
                                            fontSize: '1.05rem', 
                                            boxShadow: '0 10px 25px -5px rgba(251,191,36,0.4)', 
                                            transition: 'transform 0.2s ease' 
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                                    >
                                        Explore Naming Opportunities
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
                                        </svg>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ================= DETAILS SECTION (Warm & Elegant) ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row align-items-center g-5">
                            
                            {/* Left Column (Text) */}
                            <div className="col-lg-6 order-2 order-lg-1">
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                    style={{ background: 'rgba(251,191,36,0.12)', color: '#b45309', padding: '0.4rem 0.9rem', fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                >
                                    <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#f59e0b' }}></span>
                                    Make a Lasting Impact
                                </span>

                                <h2
                                    className="fw-bold mb-4"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3.5vw, 2.75rem)', lineHeight: 1.15, color: '#0f172a' }}
                                >
                                    Create Your <span style={{ color: '#d97706' }}>Legacy</span>
                                </h2>

                                <p className="lh-lg mb-4" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    Naming opportunities provide individuals, families, and organizations with a meaningful way to support our mission while creating a lasting legacy. Your contribution can help strengthen our programs, expand our reach, and create opportunities for future generations.
                                </p>

                                <div className="d-flex gap-3 mt-4 align-items-start">
                                    <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 mt-1" style={{ width: 24, height: 24, background: '#fbbf24' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#1e293b" strokeWidth="3">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                        <strong>Recognize Your Generosity:</strong> Dedicate a space that aligns with your philanthropic goals.
                                    </p>
                                </div>

                                <div className="d-flex gap-3 mt-3 align-items-start">
                                    <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 mt-1" style={{ width: 24, height: 24, background: '#fbbf24' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#1e293b" strokeWidth="3">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                        <strong>Support Lasting Change:</strong> Fund programs and initiatives that make a tangible difference in our community.
                                    </p>
                                </div>

                                <div className="d-flex gap-3 mt-3 align-items-start">
                                    <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 mt-1" style={{ width: 24, height: 24, background: '#fbbf24' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#1e293b" strokeWidth="3">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                        <strong>Build Brighter Futures:</strong> Celebrate your commitment to stronger communities and future generations.
                                    </p>
                                </div>
                            </div>

                            {/* Right Column (Image) */}
                            <div className="col-lg-6 order-1 order-lg-2">
                                <div className="position-relative mx-auto" style={{ maxWidth: '500px' }}>
                                    <div
                                        className="position-absolute w-100 h-100 rounded-4"
                                        style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', transform: 'rotate(-3deg)', zIndex: 0, opacity: 0.8 }}
                                    ></div>
                                    <img
                                        src="/assets/images/fundraising/02_naming_opportunities_plaque.png"
                                        alt="Naming Opportunities"
                                        className="position-relative img-fluid rounded-4 shadow-lg w-100"
                                        style={{ zIndex: 1, aspectRatio: '4/3', objectFit: 'cover' }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* ================= BOTTOM CTA SECTION ================= */}
                <section className="py-5 position-relative overflow-hidden" style={{ background: '#fff', paddingTop: '5rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9 text-center">
                                <h3
                                    className="fw-bold mb-3"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', color: '#0f172a' }}
                                >
                                    Ready to discuss naming opportunities?
                                </h3>
                                <p className="text-muted mb-4 mx-auto" style={{ maxWidth: 560 }}>
                                    Whether you are an individual donor, a family, or a corporate partner, we welcome the opportunity to work with you to identify an option that aligns with your interests.
                                </p>
                                <Link to="/campaign-contact" className="text-decoration-none">
                                    <button
                                        className="btn fw-bold rounded-pill border-0 px-4 py-3"
                                        style={{ background: '#1e293b', color: '#ffffff', boxShadow: '0 10px 25px -5px rgba(30,41,59,0.3)', transition: 'transform 0.2s ease' }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                                    >
                                        Contact Our Team
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <FundraisingFooter />
        </>
    );
};

export default NamingOpportunities;